<section>
  <!-- Added a special class even though we probably want to make this header into a component -->
  <div class="header header-system-overview">
    <h1>{{ 'DASHBOARD.OVERVIEW_ITEM_HEADER' | translate }}</h1>
    <div class="system-overview__global-search-wrapper">
      <app-global-search />
    </div>
  </div>
  <div class="data-group">
    <app-notification-board></app-notification-board>
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-6 data-group">
      <div class="row">
        <div class="col-10">
          <a class="caption h-100" routerLink="my-property/dwelling"
            >{{ 'STATISTICS.DWELLING_HEADER' | translate }}<span class="arrow-right"></span
          ></a>
        </div>
      </div>
      <app-residential-property-statistics [model]="dwelling"></app-residential-property-statistics>
    </div>
    <div class="col-lg-6 col-md-6 data-group">
      <div class="row">
        <div class="col-10">
          <a class="caption h-100" routerLink="my-property/premises"
            >{{ 'STATISTICS.PREMISES_HEADER' | translate }}<span class="arrow-right"></span
          ></a>
        </div>
      </div>
      <app-residential-property-statistics [model]="premises"></app-residential-property-statistics>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-6 data-group">
      <div class="row">
        <div class="col-10">
          <a class="caption h-100" routerLink="my-property/parking"
            >{{ 'STATISTICS.PARKING_HEADER' | translate }}<span class="arrow-right"></span
          ></a>
        </div>
      </div>
      <app-non-residential-property-statistics [model]="parking"></app-non-residential-property-statistics>
    </div>
    <div class="col-lg-6 col-md-6 data-group">
      <div class="row">
        <div class="col-10">
          <a class="caption h-100" routerLink="my-property/other-rental-object"
            >{{ 'STATISTICS.OTHER_RENTAL_OBJECT_HEADER' | translate }}<span class="arrow-right"></span
          ></a>
        </div>
      </div>
      <app-non-residential-property-statistics [model]="otherRentalObject"></app-non-residential-property-statistics>
    </div>
  </div>
</section>
<app-news-popup
  [disabled]="newsDisabled"
  [headline]="newsHeadline"
  [description]="newsDescription"
  [mediaUrl]="newsMediaUrl"
  [mediaAltText]="newsMediaAltText"
  [linkUrl]="newsLinkUrl"
  [linkButtonLabel]="newsLinkText"
  [visible]="showNewsPopup"
  (closed)="onNewsPopupClosed()"
  (stopShowing)="onNewsPopupStopShowing(newsHeadline)"
/>
